var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitch12Pole({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M3.16,12.48c-1.27,0-2.31-1.04-2.31-2.31s1.04-2.31,2.31-2.31s2.31,1.04,2.31,2.31S4.43,12.48,3.16,12.48z  M3.16,8.37c-1,0-1.81,0.81-1.81,1.81c0,1,0.81,1.81,1.81,1.81s1.81-0.81,1.81-1.81C4.97,9.18,4.16,8.37,3.16,8.37z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "4.7,8.71 4.26,8.48 7.1,3.23 9.5,4.42 9.28,4.87 7.32,3.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M8.67,12.68c-1.27,0-2.31-1.04-2.31-2.31s1.04-2.31,2.31-2.31s2.31,1.04,2.31,2.31S9.94,12.68,8.67,12.68z  M8.67,8.57c-1,0-1.81,0.81-1.81,1.81s0.81,1.81,1.81,1.81s1.81-0.81,1.81-1.81S9.66,8.57,8.67,8.57z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "10.21,8.92 9.77,8.68 12.61,3.45 15.01,4.63 14.79,5.08 12.82,4.11  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 12.9,
    y: 4.3,
    transform: "matrix(0.4618 -0.887 0.887 0.4618 2.1845 14.6366)",
    className: "st2",
    width: 0.5,
    height: 2.43
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitch12Pole);
export default __webpack_public_path__ + "static/media/Switch12Pole.c2b368c2ee3662ec0462331a994d5793.svg";
export { ForwardRef as ReactComponent };